import { Typography } from "@material-ui/core";
import { EmployeeFormData } from "Components/HumanResources/Employees/EmployeeEdit/EmployeeEditForm";
import * as React from "react";
import { UseFormMethods } from "react-hook-form";
import styled from "styled-components";
import { Resources, useResource } from "Translations/Resources";
import { nameof } from "Utils/ObjectUtils";
import {
  CheckboxCheckedIcon,
  CheckboxUncheckedIcon,
} from "Components/Shared/Icons";

type Props = {
  form: UseFormMethods<EmployeeFormData>;
};

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(auto, 450px) 1fr;
  gap: ${props => props.theme.spacing(1, 3)};
  align-items: center;
  margin-bottom: ${props => props.theme.spacing(5)}px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
    gap: 0;
  }
`;

const StyledCheckBox = styled.div`
  display: inline-flex;
  align-items: center;
  cursor: pointer;

  p {
    margin-left: 10px;
  }
`;

export const EmployeeEditHelpdeskWriting: React.FunctionComponent<Props> = props => {
  const { t } = useResource();
  const { register, watch, setValue } = props.form;
  const { isHelpdeskWritingDisabled } = watch();

  React.useEffect(() => {
    register({ name: nameof<EmployeeFormData>("isHelpdeskWritingDisabled") });
  }, [register]);

  const handleClick = () => {
    setValue(
      nameof<EmployeeFormData>("isHelpdeskWritingDisabled"),
      !isHelpdeskWritingDisabled,
    );
  };

  return (
    <div>
      <div className={"form-title"}>
        {t(Resources.HumanResources.EmployeeEdit.Helpdesk.Label)}
      </div>
      <StyledWrapper>
        <div>
          <StyledCheckBox onClick={handleClick}>
            {isHelpdeskWritingDisabled ? (
              <CheckboxCheckedIcon />
            ) : (
              <CheckboxUncheckedIcon />
            )}
            <Typography>
              {t(Resources.HumanResources.EmployeeEdit.Helpdesk.Checkbox)}
            </Typography>
          </StyledCheckBox>
        </div>
      </StyledWrapper>
    </div>
  );
};
